<template>
  <span v-if="selectedItem && selectedItem.descr">
    : {{ selectedItem.descr }}
  </span>
</template>

<script>
export default {
  data() {
    return {
      selectedItem: null
    };
  },
  props: {
    garantia: {
      type: Object,
      required: true
    }
  },
  mounted() {
    if (!this.garantia.obligatoria || this.garantia.franquicia) {
      Object.values(this.garantia.items).forEach(item => {
        // console.log("item "+JSON.stringify(item))
        if (item.selected) {
          this.selectedItem = item;
        }
      });
    }
  }
};
</script>

<style scoped></style>
